import React from "react";
import CodeEditorMock from "./CodeEditorMock";

const InterestsPanel = () => {
  return (
    <div className="interestspanel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          interests
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content">
        <CodeEditorMock>
          Outside of coding, I'm someone who’s deeply curious and always
          building or exploring something new. I love diving into{" "}
          <span class="nodejs-color-text">game development</span>,{" "}
          <span class="html-color-text">data experiments</span>, and{" "}
          <span class="docker-color-text">automation projects</span> that often
          start as simple ideas and turn into useful tools or fun prototypes.
          <br />
          <br />
          I'm also fascinated by{" "}
          <span class="html-color-text">hardware hacking</span> — especially
          with <span class="html-color-text">Raspberry Pi</span> and IoT-like
          setups. I enjoy making small systems that interact with the physical
          world — like access systems, loggers, or smart home add-ons.
          <br />
          <br />
          Beyond the screen, I'm a huge fan of the sea. I was a{" "}
          <span class="true-color-text">licensed sailor as a kid</span> and
          competed in{" "}
          <span class="true-color-text">youth sailing tournaments</span>. That
          passion never left me — I still go sailing when I can, and{" "}
          <span class="true-color-text">maritime culture</span> continues to
          inspire me in both life and design.
          <br />
          <br />I also love <span class="nodejs-color-text">long walks</span> to
          clear my mind,{" "}
          <span class="nodejs-color-text">playing video games</span> (for both
          fun and inspiration), and building mini-apps that combine tech with
          everyday needs.
          <br />
          <br />
          Whether it’s a side project, a sailing trip, or a quiet walk — I
          believe that exploration fuels creativity.
          <br />
          <br />
          One last thing, <span className="return-color">i love my cat.</span>
        </CodeEditorMock>
      </div>
    </div>
  );
};

export default InterestsPanel;
